/**
 * Product description expand/collapse and PDP collapsible tabs (button + aria-expanded).
 */
(function () {
  function initProductDesc(root) {
    root.querySelectorAll('[data-product-desc]').forEach(function (wrap) {
      const expandBtn = wrap.querySelector('[data-desc-expand]');
      const collapseBtn = wrap.querySelector('[data-desc-collapse]');
      const shortEl = wrap.querySelector('.short-description');
      const fullEl = wrap.querySelector('.full-description');
      if (!expandBtn || !collapseBtn || !fullEl) return;

      expandBtn.addEventListener('click', function () {
        fullEl.hidden = false;
        if (shortEl) shortEl.hidden = true;
        expandBtn.setAttribute('aria-expanded', 'true');
        collapseBtn.focus();
      });

      collapseBtn.addEventListener('click', function () {
        fullEl.hidden = true;
        if (shortEl) shortEl.hidden = false;
        expandBtn.setAttribute('aria-expanded', 'false');
        expandBtn.focus();
      });
    });
  }

  function initCollapsibleTabs(root) {
    root.querySelectorAll('[data-collapsible-tab]').forEach(function (tab) {
      const btn = tab.querySelector('.tab_titles--trigger');
      const panel = tab.querySelector('.tab_qt_anss[role="region"]');
      const icon = tab.querySelector('.plus_icons');
      if (!btn || !panel) return;

      btn.addEventListener('click', function () {
        const open = btn.getAttribute('aria-expanded') === 'true';
        const nextOpen = !open;
        btn.setAttribute('aria-expanded', nextOpen ? 'true' : 'false');
        if (icon) icon.classList.toggle('rotated', nextOpen);
        const $ = window.jQuery;
        if ($) {
          $(panel).slideToggle();
        } else {
          panel.style.display = nextOpen ? 'block' : 'none';
        }
      });
    });
  }

  function run(root) {
    initProductDesc(root);
    initCollapsibleTabs(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    run(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) run(event.target);
  });
})();
